import { MessageService } from 'primeng/api';
import io, { Socket } from 'socket.io-client';

import { EventEmitter, Injectable } from '@angular/core';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socket: Socket;
  disconnected = false;
  dateDisconnect: Date | undefined = undefined;

  onSocketInit: EventEmitter<void> = new EventEmitter();
  connectEvent: EventEmitter<void> = new EventEmitter();
  reloadEvent: EventEmitter<Date> = new EventEmitter();
  disconnectEvent: EventEmitter<void | string> = new EventEmitter();

  constructor(private settingsService: SettingsService, private messageService: MessageService) {
    this.socket = io(this.settingsService.settings.socket, {
      transports: ['websocket'],
      upgrade: true,
      reconnection: true,
      rememberUpgrade: true,
      onlyBinaryUpgrades: true,
      randomizationFactor: 1,
      reconnectionDelay: Math.random() * 10000,
    });

    this.socket.on('connect', () => {
      this.connectEvent.emit();
      if (this.disconnected) {
        this.disconnected = false;
        if (this.dateDisconnect) {
          this.reloadEvent.emit(this.dateDisconnect);
          this.messageService.add({
            severity: 'success',
            summary: this.settingsService.translate[this.settingsService.selectedLang]['connect'],
          });
        }
      }
    });

    this.socket.on('disconnect', () => {
      this.disconnected = true;
      this.dateDisconnect = new Date();
      this.disconnectEvent.emit();
      this.messageService.add({
        severity: 'error',
        summary: this.settingsService.translate[this.settingsService.selectedLang]['disconnect'],
      });
    });

    this.socket.on('connect_error', (err: any) => {
      this.disconnectEvent.emit(err);
    });

  }

  getId(): string {
    return this.socket.id;
  }

  public send<T>(command: string, data: T): void {
    this.socket.emit(command, JSON.stringify(data));
  }

  hasListener(command: string): boolean {
    return this.socket && this.socket.hasListeners(command);
  }

  public addListener<T>(command: string, callback: Function) {
    if (this.socket == null) {
      this.onSocketInit.subscribe(() => {
        if (this.socket.hasListeners(command)) {
          this.removeListener(command);
        }
        this.socket.on(command, (res: T) => {
          callback(res);
        });
      });
    } else {
      if (this.socket.hasListeners(command)) {
        this.removeListener(command);
      }
      this.socket.on(command, (res: T) => {
        callback(res);
      });
    }
  }

  public removeListener(command: string) {
    if (this.socket == null) {
      this.onSocketInit.subscribe(() => {
        this.socket.removeListener(command);
      });
    } else {
      this.socket.removeListener(command);
    }
  }
}
